export class AwsDynamoDbResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "billingMode",
            "baseName": "billingMode",
            "type": "DynamoDbBillingMode",
            "format": ""
        },
        {
            "name": "readCapacityUnits",
            "baseName": "readCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "globalSecondaryIndexes",
            "baseName": "globalSecondaryIndexes",
            "type": "Array<DynamoDbGlobalSecondaryIndex>",
            "format": ""
        },
        {
            "name": "localSecondaryIndexes",
            "baseName": "localSecondaryIndexes",
            "type": "Array<DynamoDbLocalSecondaryIndex>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbResource.attributeTypeMap;
    }
    constructor() {
    }
}
